import React from 'react'
import { GeneralAdvisorData, AdvisorData, RoboAdvisorData } from '../../../utils/types'
import { AdvisorCard } from './AdvisorCard'

interface AdvisorCardsProps {
  advisorsData: GeneralAdvisorData
}

export const AdvisorCards = ({ advisorsData }: AdvisorCardsProps) => (
  <>
    {(advisorsData as (AdvisorData | RoboAdvisorData)[]).map((advisorData, index) => (
      <AdvisorCard key={`advisor-${index}`} advisorData={advisorData} position={index + 1}/>
    ))}
  </>
)
